export default {
  addressSelected: null,
};
